<template>
  <div id="myartworks">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li class="active">
          <a href="#/myartworks">My Artworks</a>
        </li>
      </ol>
    </div>

    <div class="content login middle" v-loading="loading">
      <div class="cell">
        <div class="container">
          <div class="row mt20">
            <p class="sub-title text-center">MY ARTWORKS</p>

            <div class="col-xs-12 mb10">
              <a href="#/collection">
                <span class="iconfont2 icon-g7 button-icon mr20"></span>
                <span class="font16 black text-middle">CREATE NEW ARTWORK</span>
              </a>
            </div>

            <div v-if="artworkList.length > 0">
              <div class="col-xs-7">
                <el-input
                  v-model="artwork_query"
                  size="big"
                  suffix-icon="el-icon-search"
                  placeholder="FIND AN ARTWORK"
                  class="mb20"
                ></el-input>
                <table class="table mb0"></table>

                <div
                  class="scroll-wrapper infinite-list-wrapper"
                  style="overflow: auto !important"
                >
                  <table class="table table-hover">
                    <tr>
                      <th class="w25">
                        <a
                          :class="{
                            active: sortKey == 'name',
                            desc: reverseSort,
                            sort: true,
                          }"
                          @click="sort_by('name')"
                          >Name</a
                        >
                      </th>
                      <th>
                        <a
                          :class="{
                            active: sortKey == 'product',
                            desc: reverseSort,
                            sort: true,
                          }"
                          @click="sort_by('product')"
                          >Product</a
                        >
                      </th>
                      <th class="w15">
                        <a
                          :class="{
                            active: sortKey == 'protocol',
                            desc: reverseSort,
                            sort: true,
                          }"
                          @click="sort_by('protocol')"
                          >Protocol</a
                        >
                      </th>
                      <th class="text-right w20">
                        <a
                          :class="{
                            active: sortKey == 'modified_at',
                            desc: reverseSort,
                            sort: true,
                          }"
                          @click="sort_by('modified_at')"
                          >Last Update</a
                        >
                      </th>
                    </tr>
                    <tbody>
                      <tr
                        :class="activeClass == i._id ? 'active' : ''"
                        v-for="(i, index) in displayedArtwork"
                        @click="selectArtwork(i._id)"
                        :key="index"
                      >
                        <td class="w25">{{ i.name }}</td>
                        <td>{{ i.product }}</td>
                        <td class="w15">{{ i.protocol }}</td>
                        <td class="text-right w20">
                          {{
                            new Date(i.modified_at) | dateFormat("DD.MM.YYYY")
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <nav class="text-center" v-if="pages.length > 0">
                    <ul class="pagination">
                      <li v-if="page != 1" @click="page--">
                        <a aria-label="Previous">
                          <span
                            aria-hidden="true"
                            class="iconfont3 icon-back font11"
                          ></span>
                        </a>
                      </li>
                      <li
                        v-for="(pageNumber, index) in pages.slice(
                          page - 1,
                          page + 5
                        )"
                        @click="page = pageNumber"
                        :key="index"
                      >
                        <a :class="{ active: pageNumber == page }">{{
                          pageNumber
                        }}</a>
                      </li>
                      <li @click="page++" v-if="page < pages.length">
                        <a aria-label="Next">
                          <span
                            aria-hidden="true"
                            class="iconfont3 icon-next font11"
                          ></span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>

              <div class="col-xs-5 text-center">
                <div style="height: 290px; line-height: 290px">
                  <img
                    class="artwork_preview"
                    :src="checkImg(artwork.img)"
                    alt
                  />
                </div>
                <div class="mt20">
                  <router-link
                    :to="'/artwork/' + artwork._id"
                    class="black mr20"
                    >Open</router-link
                  >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Edit"
                    placement="top"
                  >
                    <a
                      class="black mr20"
                      data-toggle="modal"
                      data-target="#edit"
                    >
                      <span class="iconfont3 icon-edit font18"></span>
                    </a>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Duplicate"
                    placement="top"
                  >
                    <a class="black mr20" @click="copy_artwork(artwork)" v-if="!isArtworkObsolete()">
                      <span class="iconfont3 icon-copy font18"></span>
                    </a>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Delete"
                    placement="top"
                  >
                    <a class="black mr20" @click="delete_artwork()">
                      <span class="iconfont3 icon-delete font18"></span>
                    </a>
                  </el-tooltip>

                  <a class="black" @click="design()" v-if="!isArtworkObsolete()">Engraving</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="edit"
      tabindex="-1"
      role="dialog"
      aria-labelledby
      data-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p class="font18 text-center">EDIT ARTWORK</p>
            <div class="row">
              <div class="col-xs-8 col-xs-offset-2">
                <table class="table mt30 font12">
                  <tr>
                    <td>Name</td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        v-model="artwork.name"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="text-middle">Communication protocol</td>
                    <td class="text-right text-middle">
                      <el-select v-model="artwork.protocol" placeholder>
                        <el-option
                          v-for="item in protocols"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </td>
                  </tr>
                </table>
                <div
                  class="mt30"
                  style="padding: 12px 24px; border: 1px solid #000"
                  v-if="!isArtworkObsolete()"
                >
                  <router-link
                    data-dismiss="modal"
                    style="width: 100%"
                    :to="'/collection/engraving/' + artwork._id"
                    class="black mr20"
                  >
                    Edit in the Artwork Tool
                    <div style="float: right">
                      <span class="iconfont3 icon-edit font18"></span>
                    </div>
                  </router-link>
                </div>
                <div class="mt50 text-center">
                  <div class="row mlr0">
                    <div class="col-xs-6">
                      <button
                        type="button"
                        data-dismiss="modal"
                        aria-label="Close"
                        class="el-button"
                      >
                        Cancel
                      </button>
                    </div>
                    <div class="col-xs-6">
                      <button
                        type="button"
                        class="el-button el-button--primary"
                        @click="edit_artwork()"
                      >
                        Done
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import isArtworkObsolete from "../mixins/isArtworkObsoleteMixin"

export default {
  name: "myartworks",
  mixins: [isArtworkObsolete],
  data() {
    return {
      temp_list: [],
      artwork_query: "",
      artworkList: [],
      artwork: {},
      activeClass: null,
      loading: true,
      start_art: 0,
      end_art: 5,
      sortKey: "modified_at",
      reverseSort: true,
      page: 1,
      pages: [],
      perPage: 5,
      protocols: [
        {
          label: "Crestron",
          value: "Crestron",
        },
        {
          label: "KNX",
          value: "KNX",
        },
        {
          label: "RS485",
          value: "RS485",
        },
      ],
    };
  },
  computed: {
    filtered_artwork: function () {
      var a = this.artworkList.filter((artwork) => {
        return artwork.name
          .toLowerCase()
          .includes(this.artwork_query.toLowerCase());
      });
      return this.sortArrayOfObjects(a, this.sortKey, this.reverseSort);
    },
    displayedArtwork() {
      return this.paginate(this.filtered_artwork);
    },
  },
  watch: {
    filtered_artwork(newItems) {
      this.set_pages(newItems);
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    sort_by(sortKey) {
      this.reverseSort = this.sortKey == sortKey ? !this.reverseSort : false;
      this.sortKey = sortKey;
    },
    set_pages(items) {
      this.page = 1;
      this.pages = [];
      let numberOfPages = Math.ceil(items.length / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(items) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return items.slice(from, to);
    },
    sortArrayOfObjects(arr, column, reverse) {
      arr.sort(function (a, b) {
        var textA = a[column].toUpperCase();
        var textB = b[column].toUpperCase();
        if (!reverse) {
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return textA < textB ? 1 : textA > textB ? -1 : 0;
        }
      });
      return arr;
    },
    checkImg(img) {
      if (typeof img == "undefined") return;
      if (img.includes("data:image")) {
        return img;
      } else {
        return (
          this.$store.state.serverURL + "/artwork/" + img + "?" + Date.now()
        );
      }
    },
    design: function () {
      this.$router.push({ path: "/collection/engraving/" + this.artwork._id });
    },
    getData: function () {
      this.loading = true;
      axios
        .get("/artwork/" + this.$store.state.user._id)
        .then((response) => {
          this.artworkList = response.data.map((a) => {
            a.product = this.productText(a);
            return a;
          });
          this.artwork =
            Object.keys(this.artwork).length > 0
              ? this.artwork
              : this.displayedArtwork[0] || {};
          this.activeClass = this.artwork._id;
          this.loading = false;
        })
        .catch(function (error) {
          // 请求失败处理
          this.loading = false;
          alert(error);
        });
    },
    productText(item) {
      if (Object.keys(item).length == 0) {
        return;
      }
      var left = "";
      var right = "";
      var tripleRight = "";
      if (item.layout == "M1" || item.layout == "TT") {
        left = ", " + item.layout;
      } else {
        left = ", " + item.layout.substring(1) + " Buttons";
      }
      if (item.format != "single") {
        if (item.rightLayout == "M1" || item.rightLayout == "TT") {
          right = ", " + item.rightLayout;
        } else {
          right = ", " + item.rightLayout.substring(1) + " Buttons";
        }
      }
      if (item.format == "triple") {
        if (item.tripleRightLayout == "M1" || item.tripleRightLayout == "TT") {
          tripleRight = ", " + item.tripleRightLayout;
        } else {
          tripleRight = ", " + item.tripleRightLayout.substring(1) + " Buttons";
        }
      }
      return (
        item.type.toUpperCase() +
        " " +
        item.format.charAt(0).toUpperCase() +
        item.format.slice(1) +
        left +
        right +
        tripleRight
      );
    },
    selectArtwork(id) {
      this.artwork = this.artworkList.find((a) => a._id == id);
      this.activeClass = id;
    },
    delete_artwork() {
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE ARTWORK",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: black" }, this.artwork.name + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "Deleting...";
            axios
              .delete("/artwork/" + this.artwork._id)
              .then((res) => {
                if (res.data.ok == 1) {
                  instance.confirmButtonLoading = false;
                  done();
                  this.$message({
                    type: "success",
                    message: "Delete Successfully!",
                  });

                  this.getData();
                } else {
                  instance.confirmButtonLoading = false;
                  done();
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch(function (error) {
                // 请求失败处理
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },
    edit_artwork() {
      axios
        .put("/artwork/simple/" + this.artwork._id, {
          artwork: {
            name: this.artwork.name,
            protocol: this.artwork.protocol,
          },
        })
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Edit Successfully!",
            });
            window.$("#edit").modal("hide");
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: "Edit Failed!",
            });
            window.$("#edit").modal("hide");
          }
        })
        .catch(function (error) {
          // 请求失败处理
          alert(error);
        });
    },
    copy_artwork(item) {
      this.loading = true;
      axios
        .post("/artwork/duplicate", {
          artwork: item,
        })
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Copied!",
            });
            this.loading = false;
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: "Copy Failed!",
            });
            this.loading = false;
            window.console.log(res);
          }
        })
        .catch(function (error) {
          // 请求失败处理
          this.loading = false;
          window.console.log(error);
        });
    },
  },
};
</script>
